const matchesProfile = (profile, user) =>
  profile !== null &&
  typeof profile === 'object' &&
  !Array.isArray(profile) &&
  profile.type === user.type &&
  typeof profile.email === 'string' &&
  profile.email.toLowerCase() === user.email.toLowerCase();

// Dependency injection keeps Firebase initialization and production writes out of tests.
export async function recordNewSession(user, read, transact, now = new Date()) {
  if (!['Teacher', 'Student'].includes(user?.type) || typeof user.email !== 'string' || !user.email) return false;
  const emailKey = user.email.replace(/\./g, '');
  const key = user.mail || emailKey;
  if (typeof key !== 'string' || key.toLowerCase() !== emailKey.toLowerCase()) return false;
  const path = `${user.type === 'Teacher' ? 'Teachers' : 'Students'}/${key}`;
  const snapshot = await read(path);
  if (!snapshot.exists() || !matchesProfile(snapshot.val(), user)) return false;

  const timestamp = now.toISOString().slice(0, 19).replace('T', ' ');
  const result = await transact(path, profile => {
    // Revalidate on every retry: a deleted or incomplete profile must never be recreated.
    if (!matchesProfile(profile, user)) return undefined;
    const sessions = Array.isArray(profile.sessionStartTime) ? profile.sessionStartTime : [];
    return { ...profile, sessionStartTime: [...sessions, timestamp] };
  });
  return result.committed;
}
